
import React, { useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import "./EmployeeListMaster.css";
// Simple modal for editing employee
function EditEmployeeModal({ show, onClose, employee }) {
  if (!show || !employee) return null;
  return (
    <div className="modal-backdrop" style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.3)', zIndex: 1000 }}>
      <div className="modal-dialog" style={{ background: '#fff', margin: '5% auto', padding: 24, maxWidth: 600, borderRadius: 8, position: 'relative' }}>
        <h4>Edit Employee</h4>
        <div><b>Name:</b> {employee.EmpNameTitle} {employee.EmpName}</div>
        <div><b>Father's Name:</b> {employee.FatherNameTitle} {employee.FatherName}</div>
        <div><b>Gender:</b> {employee.Gender}</div>
        {/* Add more fields as needed */}
        <button className="btn btn-secondary mt-3" onClick={onClose}>Close</button>
      </div>
    </div>
  );
}
const PRINTING_LOTS = [
  { value: "", label: "ALL" },
  { value: "P1", label: "P1 — 1st Batch" },
  { value: "P2", label: "P2 — TeachingPermanent" },
  { value: "P3", label: "P3 — NonTeachingPermanent" },
  { value: "P4", label: "P4 — NonTeachingPermanent" },
  { value: "P5", label: "P5 — TeachingPermanent" },
  { value: "P6", label: "P6 — AcademicStaff" },
  { value: "P7", label: "P7 — NonTeachingPermanent" },
  { value: "P8", label: "P8 — TeachingPermanent" },
  { value: "P9", label: "P9 — NonTeachingPermanent" },
  { value: "P10", label: "P10 — Pending" },
  { value: "P11", label: "P11 — TeachingPermanent" },
  { value: "P12", label: "P12 — NonTeachingPermanent" },
  { value: "P13", label: "P13 — NonTeachingPermanent" },
  { value: "P14", label: "P14 — TeachingPermanent" },
  { value: "P16", label: "P16 — ExtSer(Tea)" },
  { value: "P18", label: "P18 — ExtSer(NonTea)" },
  { value: "P20", label: "P20 — DailyWages" },
  { value: "P21", label: "P21 — DailyWages" },
  { value: "P22", label: "P22 — DailyWages" },
  { value: "P23", label: "P23 — DailyWages" },
  { value: "P24", label: "P24 — DailyWages" },
  { value: "P25", label: "P25 — DailyWages" },
  { value: "P26", label: "P26 — DailyWages" },
  { value: "P27", label: "P27 — DailyWages" },
  { value: "P28", label: "P28 — Daily Wages" },
  { value: "P29", label: "P29 — Daily Wages" },
  { value: "P30", label: "P30 — MTS" },
  { value: "P50", label: "P50 — Teaching Contractual" },
  { value: "P51", label: "P51 — Teaching Contractual" },
  { value: "P52", label: "P52 — Teaching Contractual" },
  { value: "P53", label: "P53 — Teaching Contractual" },
  { value: "P60", label: "P60 — Teaching Retired" },
  { value: "P61", label: "P61 — Teaching Retired" },
  { value: "P70", label: "P70 — NonTeaching Retired" },
  { value: "P71", label: "P71 — NonTeaching Retired" },
  { value: "P72", label: "P72 — Retired" },
  { value: "P73", label: "P73 — Retired" },
  { value: "P80", label: "P80 — Retiring 2026" },
  { value: "P81", label: "P81 — Retiring 2026" },
  { value: "P95", label: "P95 — GuestFaculty" },
  { value: "P97", label: "P97 — Special Category" },
  { value: "P98", label: "P98 — NonTeachingPermanent" },
  { value: "P99", label: "P99 — TeachingPermanent" },
  { value: "P100", label: "P100 — NonTeachingPermanent" },
  { value: "P101", label: "P101 — TeachingPermanent" },
  { value: "C", label: "C — Correction" },
  { value: "P102", label: "P102 — NonTeachingPermanent" },
  { value: "P103", label: "P103 — TeachingPermanent" },
  { value: "P104", label: "P104 — Non Teaching Permanent" },
  { value: "P105", label: "P105 — Teaching Permanent" },
  { value: "P106", label: "P106 — Non Teaching Permanent" },
  { value: "P107", label: "P107 — Teaching Permanent" },
  { value: "C1", label: "C1 — Correction" },
  { value: "C2", label: "C2 — Correction" },
  { value: "C3", label: "C3 — Correction" },
  { value: "P110", label: "P110 — Contractual (Yellow)" },
  { value: "P111", label: "P111 — Permanent (Red)" },
  { value: "P112", label: "P112 — Extension (Red)" },
  { value: "P113", label: "P113 — Retired (Blue)" },
  { value: "C4", label: "C4 — Correction" },
  { value: "P114", label: "P114 — Contractual (Yellow)" },
  { value: "P115", label: "P115 — Permanent (Red)" },
  { value: "P116", label: "P116 — Extension (Red)" },
  { value: "P117", label: "P117 — Retired (Blue)" },
  { value: "C5", label: "C5 — Correction" },
  { value: "P118", label: "P118 — Mixed Lot" },
  { value: "C6", label: "C6 — Correction" },
  { value: "P500", label: "P500 — Not in Use" },
];

const EMP_TYPES = [
  { value: "", label: "ALL" },
  { value: "N", label: "NonTea" },
  { value: "T", label: "Teach" },
  { value: "A", label: "AcaStf" },
];

const JOB_TYPES = [
  { value: "", label: "ALL" },
  { value: "P", label: "Permt" },
  { value: "T", label: "Tempy" },
  { value: "C", label: "Contal" },
  { value: "D", label: "DaiWag" },
  { value: "M", label: "MTS" },
  { value: "V", label: "Visiting" },
  { value: "G", label: "Guest" },
  { value: "O", label: "Out Sourced" },
  { value: "F", label: "Department Fund" },
];

const STATUS_TYPES = [
  { value: "", label: "ALL" },
  { value: "W", label: "Working" },
  { value: "R", label: "Retired" },
  { value: "E", label: "Extended Service" },
  { value: "X", label: "Expired" },
  { value: "H", label: "Emeritus" },
];

// Shown only for ModuleID 4 users, matching the Status dropdown on employee-edit
const MODULE4_STATUS_TYPES = [
  { value: "L", label: "Left" },
  { value: "S", label: "Suspension" },
  { value: "D", label: "Deputation" },
];

// Mapping helpers
const jobTypeMap = {
  P: 'Permnt', T: 'TemBas', C: 'Contl', D: 'DaiWgs', M: 'MTS', O: 'OutSou', G: 'GuFac', V: 'Vstng', F: 'DeptFd'
};
const serviceTypeMap = { N: 'NonTea', T: 'Techig', A: 'AcaStf' };
const statusMap = { W: 'Wrking', E: 'ExtSrv', R: 'Retred', H: 'Emrits', X: 'Expird', L: 'Left', S: 'Suspnd', D: 'Deputn' };
const activeLabelMap = { Y: 'Active', N: 'Inactive', P: 'Pending', R: 'Retired' };
function formatDate(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  if (isNaN(d)) return '';
  return d.toLocaleDateString('en-GB');
}

export default function EmployeeListMaster() {
  const localUser = useMemo(() => {
    try { return JSON.parse(localStorage.getItem("user") || "null"); } catch { return null; }
  }, []);
  const moduleId      = parseInt(localUser?.moduleId, 10);
  const deptId        = parseInt(localUser?.deptid,   10);
  const empId         = parseInt(localUser?.id,       10);
  const isDeptScoped     = [2, 15].includes(moduleId);
  // PFNo=8750 (EmployeeID=53, Sudhir Goyal) — granted the same read-only Employee List
  // view ModuleID=10 already gets (no Edit option), per individual request.
  const VIEW_ONLY_EMPLOYEE_IDS = [53];
  const isViewOnlyViewer = VIEW_ONLY_EMPLOYEE_IDS.includes(empId);
  const canEdit          = ![2, 10, 15].includes(moduleId) && !isViewOnlyViewer;
  const showElection     = [2, 4].includes(moduleId);
  const canEditElection  = [2, 4].includes(moduleId);
  const isResolverScoped = moduleId === 9;
  const statusTypes      = moduleId === 4 ? [...STATUS_TYPES, ...MODULE4_STATUS_TYPES] : STATUS_TYPES;

  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editEmployee] = useState(null);
  const [electionModal,  setElectionModal]  = useState(null);
  const [electionForm,   setElectionForm]   = useState({});
  const [electionSaving, setElectionSaving] = useState(false);
  const [electionError,  setElectionError]  = useState("");
  const [departments, setDepartments] = useState([]);
  const [casteCategories, setCasteCategories] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [filters, setFilters] = useState({
    PrintingLot: "",
    EmpType: "",
    JobType: "",
    Status: "",
    DepartmentID: "",
    CasteCategoryID: "",
    DesignationID: "",
  });
  const filtersRef = useRef(filters);
  const fetchEmployeeListRef = useRef(null);
  const selectHeightRef = useRef(null);
  const viewBtnRef = useRef(null);

  useLayoutEffect(() => {
    if (selectHeightRef.current && viewBtnRef.current) {
      const h = selectHeightRef.current.offsetHeight;
      viewBtnRef.current.style.height = `${h}px`;
      viewBtnRef.current.style.paddingTop = '0';
      viewBtnRef.current.style.paddingBottom = '0';
      viewBtnRef.current.style.lineHeight = `${h - 2}px`;
    }
  }, []);
  const [loading, setLoading] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    filtersRef.current = filters;
  }, [filters]);

  useEffect(() => {
    fetch("/api/directory/departments")
      .then((res) => res.json())
      .then((data) => Array.isArray(data) ? setDepartments(data) : setDepartments([]))
      .catch(() => setDepartments([]));
  }, []);

  useEffect(() => {
    fetch("/api/meta/castes")
      .then((res) => res.json())
      .then((data) => Array.isArray(data) ? setCasteCategories(data) : setCasteCategories([]))
      .catch(() => setCasteCategories([]));
  }, []);

  useEffect(() => {
    fetch("/api/meta/designations")
      .then((res) => res.json())
      .then((data) => Array.isArray(data) ? setDesignations(data) : setDesignations([]))
      .catch(() => setDesignations([]));
  }, []);

  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const fetchEmployeeList = async (payloadFilters) => {
    setLoading(true);
    setError("");
    setEmployees([]);
    try {
      const res = await fetch("/api/directory/employee/list", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...payloadFilters, moduleId, deptId, empId }),
      });
      if (!res.ok) throw new Error("Failed to fetch employee list");
      const data = await res.json();
      setEmployees(data);
    } catch (err) {
      setError(err.message || "Error fetching data");
    } finally {
      setLoading(false);
    }
  };
  fetchEmployeeListRef.current = fetchEmployeeList;

  const handleView = async (e) => {
    e.preventDefault();
    await fetchEmployeeList(filters);
  };

  const openElectionEdit = (row) => {
    setElectionForm({
      EmpGroup:  row.EmpGroup  || "",
      BasicPay:  row.BasicPay  != null ? String(row.BasicPay) : "",
      LongLeave: row.LongLeave || "",
      VoterID:   row.VoterID   || "",
      PollDuty:  row.PollDuty  || ""
    });
    setElectionError("");
    setElectionModal(row);
  };

  const handleElectionSave = async () => {
    if (!electionModal) return;
    setElectionSaving(true);
    setElectionError("");
    try {
      const res = await fetch(`/api/profile/edit-election/${electionModal.EmployeeID}?moduleId=${moduleId}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(electionForm)
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Failed to save");
      setElectionModal(null);
      await fetchEmployeeList(filtersRef.current);
    } catch (err) {
      setElectionError(err.message || "Failed to save");
    } finally {
      setElectionSaving(false);
    }
  };

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin !== window.location.origin) return;
      if (event.data?.type === "EMPLOYEE_EDIT_SAVED") {
        fetchEmployeeListRef.current(filtersRef.current);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);


  return (
    <div>
      <div className="container-fluid" style={{ overflowX: 'hidden' }}>
        <h3 className="ctitle">Emp List</h3>
        <form className="row g-2 align-items-start mb-2" onSubmit={handleView}>
          {!isDeptScoped && moduleId !== 10 && !isViewOnlyViewer && (
            <div className="col-auto">
              <label className="form-label mb-0 small d-block">Printing Lot</label>
              <select name="PrintingLot" className="form-select form-select-sm" style={{ width: 'auto' }} value={filters.PrintingLot} onChange={handleChange}>
                {PRINTING_LOTS.map((lot) => (
                  <option key={lot.value} value={lot.value}>{lot.label}</option>
                ))}
              </select>
            </div>
          )}
          <div className="col-auto">
            <label className="form-label mb-0 small d-block">EmpType</label>
            <select ref={selectHeightRef} name="EmpType" className="form-select form-select-sm" style={{ width: 'auto' }} value={filters.EmpType} onChange={handleChange}>
              {EMP_TYPES.map((t) => (
                <option key={t.value} value={t.value}>{t.label}</option>
              ))}
            </select>
          </div>
          <div className="col-auto">
            <label className="form-label mb-0 small d-block">JobType</label>
            <select name="JobType" className="form-select form-select-sm" style={{ width: 'auto' }} value={filters.JobType} onChange={handleChange}>
              {JOB_TYPES.map((t) => (
                <option key={t.value} value={t.value}>{t.label}</option>
              ))}
            </select>
          </div>
          <div className="col-auto">
            <label className="form-label mb-0 small d-block">Status</label>
            <select name="Status" className="form-select form-select-sm" style={{ width: 'auto' }} value={filters.Status} onChange={handleChange}>
              {statusTypes.map((t) => (
                <option key={t.value} value={t.value}>{t.label}</option>
              ))}
            </select>
          </div>
          <div className="col-auto">
            <label className="form-label mb-0 small d-block">Caste Category</label>
            <select name="CasteCategoryID" className="form-select form-select-sm" style={{ maxWidth: '220px' }} value={filters.CasteCategoryID} onChange={handleChange}>
              <option value="">ALL</option>
              {casteCategories.map((c) => (
                <option key={c.CasteCategoryID} value={c.CasteCategoryID}>{c.CasteCategory}</option>
              ))}
            </select>
          </div>
          <div className="col-auto">
            <label className="form-label mb-0 small d-block">Designation</label>
            <select name="DesignationID" className="form-select form-select-sm" style={{ maxWidth: '220px' }} value={filters.DesignationID} onChange={handleChange}>
              <option value="">ALL</option>
              {designations.map((d) => (
                <option key={d.DesignationID} value={d.DesignationID}>{d.Designation}</option>
              ))}
            </select>
          </div>
          {!isDeptScoped && (
            <div className="col-auto">
              <label className="form-label mb-0 small d-block">Department</label>
              <select name="DepartmentID" className="form-select form-select-sm" style={{ maxWidth: '220px' }} value={filters.DepartmentID} onChange={handleChange}>
                <option value="">ALL</option>
                {departments.map((d) => (
                  <option key={d.DepartmentID} value={d.DepartmentID}>{d.Department}</option>
                ))}
              </select>
            </div>
          )}
          <div className="col-auto">
            <label className="form-label mb-0 small d-block">View</label>
            <button ref={viewBtnRef} className="btn btn-success btn-sm" type="submit" disabled={loading}>
              {loading ? "Loading..." : "View"}
            </button>
          </div>
        </form>
        {error && <div className="alert alert-danger">{error}</div>}
      </div>
      <div className="px-2" id="RptEmpList">
          {isResolverScoped && employees.length > 0 && (
            <h5 className="text-center my-2">{employees[0].ResolverName}</h5>
          )}
          {employees.length > 0 ? (
            <div style={{ position: 'relative' }}>
              <div id="employee-table-scrollable">
                <table className="table table-striped table-sm align-middle employee-list-table" style={{ borderCollapse: 'separate', borderSpacing: 0 }}>
                  <thead style={{ '--bs-table-bg': '#008080', color: 'white', position: 'sticky', top: 'var(--app-header-offset, 72px)', zIndex: 4 }}>
                    <tr>
                      <th style={{ position: 'sticky', left: 0, zIndex: 5, background: '#008080', minWidth: '45px', width: '45px' }}>SNo</th>
                      <th style={{ position: 'sticky', left: '45px', zIndex: 5, background: '#008080', whiteSpace: 'nowrap', borderRight: '2px solid #555' }}>Name</th>
                      <th style={{ whiteSpace: 'nowrap' }}>Gender</th>
                      <th style={{ whiteSpace: 'nowrap' }}>Father's Name</th>
                      <th>Mobile</th>
                      <th style={{ whiteSpace: 'nowrap' }}>PF/PPO</th>
                      <th style={{ whiteSpace: 'nowrap' }}>Email</th>
                      <th>DOB</th>
                      <th>Valid Upto</th>
                      <th style={{ minWidth: '150px' }}>Designation</th>
                      {isResolverScoped && <th style={{ whiteSpace: 'nowrap' }}>DOJ</th>}
                      {isResolverScoped && <th style={{ whiteSpace: 'nowrap' }}>DOC</th>}
                      <th style={{ minWidth: '280px' }}>Department</th>
                      <th style={{ minWidth: '300px' }}>Address</th>
                      <th style={{ minWidth: '160px' }}>City</th>
                      <th>State</th>
                      <th>PIN</th>
                      <th>JobTyp</th>
                      <th>SerTyp</th>
                      <th>Status</th>
                      {isResolverScoped && <th>Active</th>}
                      <th>BGrp</th>
                      <th>EmgMobile</th>
                      <th>Lock</th>
                      <th>Lot</th>
                      <th>Category</th>
                      <th style={{ whiteSpace: 'nowrap', width: '1%' }}>Pic</th>
                      <th style={{ whiteSpace: 'nowrap', width: '1%' }}>Doc</th>
                      {canEdit ? <th style={{ whiteSpace: 'nowrap', width: '1%' }}>Edit</th> : null}
                      {showElection && <th style={{ whiteSpace: 'nowrap' }}>Grp</th>}
                      {showElection && <th style={{ whiteSpace: 'nowrap' }}>BasicPay</th>}
                      {showElection && <th style={{ whiteSpace: 'nowrap' }}>LongLv</th>}
                      {showElection && <th style={{ whiteSpace: 'nowrap' }}>VoterID</th>}
                      {showElection && <th style={{ whiteSpace: 'nowrap' }}>PollDuty</th>}
                      {canEditElection && <th style={{ whiteSpace: 'nowrap', width: '1%' }}>ElecEdit</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {employees.map((row, idx) => {
                      const picPath = row.ProfilePic ? `/api/profile/image/${encodeURIComponent(row.ProfilePic)}` : null;
                      const docPath = row.SupportingDoc ? `/api/profile/supportingdoc/${encodeURIComponent(row.SupportingDoc)}` : null;
                      return (
                        <tr key={row.EmployeeID || idx}>
                          <td style={{ position: 'sticky', left: 0, zIndex: 1, background: idx % 2 === 0 ? '#f9f9f9' : '#fff', minWidth: '45px', width: '45px' }}>{idx + 1}</td>
                          <td style={{ position: 'sticky', left: '45px', zIndex: 1, background: idx % 2 === 0 ? '#f9f9f9' : '#fff', whiteSpace: 'nowrap', borderRight: '2px solid #555' }}>{row.EmpNameTitle} {row.EmpName}</td>
                          <td style={{ whiteSpace: 'nowrap' }}>{row.Gender || ''}</td>
                          <td style={{ whiteSpace: 'nowrap' }}>{row.FatherNameTitle} {row.FatherName}</td>
                          <td>{row.Mobile}</td>
                          <td style={{ whiteSpace: 'nowrap' }}>{row.PFNo}</td>
                          <td style={{ whiteSpace: 'nowrap' }}>{row.Email}</td>
                          <td>{formatDate(row.DOB)}</td>
                          <td>{formatDate(row.DOR)}</td>
                          <td style={{ minWidth: '150px', whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'break-word' }}>{row.Designation}</td>
                          {isResolverScoped && <td>{formatDate(row.DOJ)}</td>}
                          {isResolverScoped && <td>{formatDate(row.DOC)}</td>}
                          <td style={{ minWidth: '280px', whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'break-word' }}>{row.Department}</td>
                          <td style={{ minWidth: '300px', whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'break-word' }}>{row.PermanentAddress}</td>
                          <td style={{ minWidth: '160px', whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'break-word' }}>{row.City}</td>
                          <td>{row.State}</td>
                          <td>{row.PermanentPIN}</td>
                          <td>{jobTypeMap[row.JobType] || row.JobType}</td>
                          <td>{serviceTypeMap[row.EmpType] || row.EmpType}</td>
                          <td>{statusMap[row.Status] || row.Status}</td>
                          {isResolverScoped && (
                            <td>
                              <span style={{ color: row.Active === 'Y' ? 'green' : 'red', fontWeight: 'bold' }}>
                                {activeLabelMap[row.Active] || row.Active}
                              </span>
                            </td>
                          )}
                          <td>{row.BloodGroup}</td>
                          <td>{row.EmgMobile}</td>
                          <td>{row.LockFields}</td>
                          <td>{row.Printing}</td>
                          <td>{row.CasteCategory}</td>
                          <td style={{ whiteSpace: 'nowrap' }}>
                            {picPath ? (
                              <a href={picPath} target="_blank" rel="noopener noreferrer">Pic</a>
                            ) : (
                              <span style={{ color: 'gray' }}>NoDoc</span>
                            )}
                          </td>
                          <td style={{ whiteSpace: 'nowrap' }}>
                            {docPath ? (
                              <a href={docPath} target="_blank" rel="noopener noreferrer">Doc</a>
                            ) : (
                              <span style={{ color: 'gray' }}>NoDoc</span>
                            )}
                          </td>
                          {canEdit ? (
                            <td style={{ whiteSpace: 'nowrap' }}>
                              <a
                                href={`/employee-edit/${row.EmployeeID}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={(e) => {
                                  e.preventDefault();
                                  window.open(`/employee-edit/${row.EmployeeID}`, "_blank", "width=1200,height=850,scrollbars=yes,resizable=yes");
                                }}
                              >
                                Edit
                              </a>
                            </td>
                          ) : null}
                          {showElection && <td style={{ whiteSpace: 'nowrap' }}>{row.EmpGroup || ""}</td>}
                          {showElection && <td style={{ whiteSpace: 'nowrap' }}>{row.BasicPay != null ? row.BasicPay : ""}</td>}
                          {showElection && <td style={{ whiteSpace: 'nowrap' }}>{row.LongLeave || ""}</td>}
                          {showElection && <td style={{ whiteSpace: 'nowrap' }}>{row.VoterID || ""}</td>}
                          {showElection && <td style={{ whiteSpace: 'nowrap' }}>{row.PollDuty || ""}</td>}
                          {canEditElection && (
                            <td style={{ whiteSpace: 'nowrap' }}>
                              <button type="button" className="btn btn-link btn-sm p-0" onClick={() => openElectionEdit(row)}>Edit</button>
                            </td>
                          )}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          ) : null}
      </div>
      {canEdit && (
        <EditEmployeeModal show={editModalOpen} onClose={() => setEditModalOpen(false)} employee={editEmployee} />
      )}

      {electionModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.4)', zIndex: 1100 }}>
          <div style={{ background: '#fff', margin: '8% auto', padding: 24, maxWidth: 520, borderRadius: 8 }}>
            <h5 className="mb-3">Election &amp; Pay — {electionModal.EmpName}</h5>
            {electionError && <div className="alert alert-danger py-1">{electionError}</div>}
            <div className="row g-2">
              <div className="col-6">
                <label className="form-label mb-1">Group</label>
                <select className="form-select form-select-sm" value={electionForm.EmpGroup}
                  onChange={e => setElectionForm(f => ({ ...f, EmpGroup: e.target.value }))}>
                  <option value="">Select</option>
                  <option value="A">A</option>
                  <option value="B">B</option>
                  <option value="C">C</option>
                  <option value="D">D</option>
                </select>
              </div>
              <div className="col-6">
                <label className="form-label mb-1">Basic Pay</label>
                <input type="number" className="form-control form-control-sm" value={electionForm.BasicPay}
                  onChange={e => setElectionForm(f => ({ ...f, BasicPay: e.target.value }))} min="0" />
              </div>
              <div className="col-6">
                <label className="form-label mb-1">Long Leave</label>
                <select className="form-select form-select-sm" value={electionForm.LongLeave}
                  onChange={e => setElectionForm(f => ({ ...f, LongLeave: e.target.value }))}>
                  <option value="">Select</option>
                  <option value="Y">Yes</option>
                  <option value="N">No</option>
                </select>
              </div>
              <div className="col-6">
                <label className="form-label mb-1">Voter ID</label>
                <input className="form-control form-control-sm" value={electionForm.VoterID} maxLength={15}
                  style={{ textTransform: 'uppercase' }}
                  onChange={e => setElectionForm(f => ({ ...f, VoterID: e.target.value.toUpperCase() }))} />
              </div>
              <div className="col-12">
                <label className="form-label mb-1">Poll Duty</label>
                <select className="form-select form-select-sm" value={electionForm.PollDuty}
                  onChange={e => setElectionForm(f => ({ ...f, PollDuty: e.target.value }))}>
                  <option value="">Select</option>
                  <option value="Presiding Officer">Presiding Officer</option>
                  <option value="Polling Officer">Polling Officer</option>
                  <option value="Polling Helper">Polling Helper</option>
                </select>
              </div>
            </div>
            <div className="d-flex gap-2 mt-3">
              <button className="btn btn-primary btn-sm" disabled={electionSaving} onClick={handleElectionSave}>
                {electionSaving ? "Saving..." : "Save"}
              </button>
              <button className="btn btn-secondary btn-sm" onClick={() => setElectionModal(null)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
